/* eslint-disable no-console */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
const { version: appVersion } = require('../../../package.json');

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
export const getBaseUrl = () => document.getElementsByTagName('base')[0].href;
const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

console.log('CURRENT VERSION: ', appVersion);

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
